if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

/* YLB variant repair 2026-09-30.1. Append-only compatibility layer for this Lumin theme.
 * Server section IDs and runtime Quick-Add IDs are intentionally different.
 * Keep live option nodes/form ownership; never import server radio IDs into a modal.
 * Installation is idempotent because Quick-Add re-executes product scripts.
 */
(() => {
  if (window.YLBVariantRepair) return;
  window.YLBVariantRepair = { version: '2026-09-30.1', ready: false };
  const byId = (root, id) => root && root.querySelector('#' + CSS.escape(id));
  const controls = root => Array.from(root.querySelectorAll('input[type="radio"][data-option-value-id], select option[data-option-value-id]'));
  const signature = root => controls(root).filter(el => el.matches('option') ? el.selected : el.checked).map(el => el.dataset.optionValueId).join(',');
  const dirty = root => controls(root).some(el => el.matches('option') ? el.selected !== el.defaultSelected : el.checked !== el.defaultChecked);
  const rootOf = picker => picker.closest('quick-add-modal') || picker.closest('[id^="MainProduct-"]') || picker.closest('.shopify-section') || picker.closest('section') || picker.parentElement;
  const localHTML = (picker, value) => picker.sectionId === picker.dataset.section ? value : value.split(picker.sectionId).join(picker.dataset.section);
  const optional = (name, action) => { try { action(); } catch (error) { console.warn('YLB variant display: ' + name, error); } };

  customElements.whenDefined('variant-selects').then(() => {
    const proto = customElements.get('variant-selects').prototype;
    Object.defineProperty(proto, 'currentVariantId', { configurable: true, get() {
      const input = byId(rootOf(this), 'product-form-' + this.dataset.section)?.querySelector('input[name="id"]');
      return input && input.value && !input.disabled ? input.value : null;
    }});
    Object.assign(proto, {
      getVariantForms() {
        const ids = ['product-form-' + this.dataset.section, 'product-form-installment-' + this.dataset.section];
        return Array.from(rootOf(this).querySelectorAll('form')).filter(form => ids.includes(form.getAttribute('id')));
      },
      getVariantButtons() {
        const forms = this.getVariantForms();
        return Array.from(rootOf(this).querySelectorAll('button[type="submit"], input[type="submit"]')).filter(button => forms.includes(button.form));
      },
      updateOptionLabels() {
        this.querySelectorAll('fieldset').forEach(fieldset => {
          const input = fieldset.querySelector('input[type="radio"]:checked');
          const label = fieldset.querySelector('[data-selected-option], [id^="selected-"]');
          if (input && label) label.textContent = ' ' + input.value;
        });
      },
      lockVariantForms() {
        this.dataset.variantState = 'pending';
        this.getVariantForms().forEach(form => {
          form.dataset.variantPending = 'true';
          form.querySelectorAll('input[name="id"]').forEach(input => { input.disabled = true; });
          form.querySelectorAll('.shopify-payment-button').forEach(payment => {
            if (!payment.hasAttribute('data-variant-was-hidden')) payment.dataset.variantWasHidden = String(payment.hidden);
            payment.hidden = true;
          });
        });
        this.getVariantButtons().forEach(button => { button.disabled = true; });
      },
      unlockVariantForms() {
        this.dataset.variantState = this.currentVariantId ? 'ready' : 'unavailable';
        this.getVariantForms().forEach(form => {
          delete form.dataset.variantPending;
          form.querySelectorAll('[data-variant-was-hidden]').forEach(payment => {
            if (!this.currentVariantId) return;
            payment.hidden = payment.dataset.variantWasHidden === 'true';
            delete payment.dataset.variantWasHidden;
          });
        });
      },
      sourcePicker(html) {
        return Array.from(html.querySelectorAll(this.tagName.toLowerCase())).find(picker => picker.dataset.section === this.sectionId);
      },
      isRenderedSection(html) {
        return !!(this.sourcePicker(html) && byId(html, 'product-form-' + this.sectionId)?.querySelector('input[name="id"]') && byId(html, 'ProductSubmitButton-' + this.sectionId));
      },
      updatePicker(html) {
        const source = this.sourcePicker(html);
        const sourceControls = new Map(controls(source).map(el => [el.dataset.optionValueId, el]));
        const liveControls = controls(this);
        if (sourceControls.size !== liveControls.length || liveControls.some(el => !sourceControls.has(el.dataset.optionValueId))) {
          throw new Error('Option structure changed; reload the product rather than guessing a variant.');
        }
        // In-place updates retain IDs, labels, focus, form ownership and modal bindings.
        liveControls.forEach(el => {
          const updated = sourceControls.get(el.dataset.optionValueId);
          if (el.matches('option')) {
            el.defaultSelected = updated.defaultSelected;
            el.selected = updated.selected;
            el.textContent = updated.textContent;
          } else {
            el.defaultChecked = updated.defaultChecked;
            el.checked = updated.checked;
          }
          el.disabled = updated.disabled;
          el.classList.toggle('disabled', updated.classList.contains('disabled'));
          if (updated.dataset.featuredMediaId) el.dataset.featuredMediaId = updated.dataset.featuredMediaId;
          else delete el.dataset.featuredMediaId;
        });
        const selectedMedia = source.dataset.featuredMediaId || controls(source).find(el => (el.checked || el.selected) && el.dataset.featuredMediaId)?.dataset.featuredMediaId;
        if (selectedMedia) this.dataset.featuredMediaId = selectedMedia;
        else delete this.dataset.featuredMediaId;
        this.preferredFeaturedMediaId = null;
        this.updateOptionLabels();
      },
      updateVariantInput(html) {
        const source = byId(html, 'product-form-' + this.sectionId).querySelector('input[name="id"]');
        const button = byId(html, 'ProductSubmitButton-' + this.sectionId);
        const buyable = !!source.value && !source.disabled && !button.disabled;
        this.getVariantForms().forEach(form => {
          form.querySelectorAll('input[name="id"]').forEach((input, index) => {
            input.value = source.value || '';
            input.disabled = !buyable || index > 0;
          });
        });
        this.dataset.confirmedVariant = source.value || '';
        this.dataset.confirmedSelection = signature(this);
      },
      updateBuyButton(html) {
        const source = byId(html, 'ProductSubmitButton-' + this.sectionId);
        this.getVariantButtons().forEach(button => {
          button.disabled = !this.currentVariantId || !source || source.disabled;
          const text = button.querySelector('span');
          if (text && source?.querySelector('span')) text.textContent = source.querySelector('span').textContent.trim();
        });
      },
      setBuyButtonLoading(loading) {
        this.getVariantButtons().forEach(button => {
          button.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
          button.toggleAttribute('aria-busy', loading);
        });
      },
      updateProductInfo(html) {
        const root = rootOf(this);
        ['price', 'Sku', 'Volume', 'Price-Per-Item', 'Inventory', 'Quantity-Rules', 'Volume-Note'].forEach(prefix => {
          const source = byId(html, prefix + '-' + this.sectionId);
          const target = byId(root, prefix + '-' + this.dataset.section);
          if (!source || !target) return;
          target.innerHTML = localHTML(this, source.innerHTML);
          target.classList.toggle('hidden', source.classList.contains('hidden') || (prefix === 'Inventory' && !source.textContent.trim()));
        });
        const sourceQty = byId(html, 'Quantity-Form-' + this.sectionId)?.querySelector('.quantity__input');
        const targetQty = byId(root, 'Quantity-Form-' + this.dataset.section)?.querySelector('.quantity__input');
        if (sourceQty && targetQty) {
          const wanted = Number(targetQty.value) || 1;
          ['data-cart-quantity', 'data-min', 'data-max', 'min', 'max', 'step'].forEach(attr => {
            if (sourceQty.hasAttribute(attr)) targetQty.setAttribute(attr, sourceQty.getAttribute(attr));
            else targetQty.removeAttribute(attr);
          });
          const inCart = Number(targetQty.dataset.cartQuantity) || 0;
          const step = Number(targetQty.step) || 1;
          const ruleMin = Number(targetQty.dataset.min) || 1;
          const min = inCart >= ruleMin ? Math.min(ruleMin, step) : ruleMin;
          const max = targetQty.hasAttribute('data-max') ? Math.max(0, Number(targetQty.dataset.max) - inCart) : Infinity;
          targetQty.min = min;
          if (Number.isFinite(max)) targetQty.max = max; else targetQty.removeAttribute('max');
          const upper = Number.isFinite(max) ? min + Math.floor((max - min) / step) * step : Infinity;
          targetQty.value = String(Math.max(min, Math.min(upper, min + Math.ceil(Math.max(0, wanted - min) / step) * step)));
        }
      },
      updateMedia() {
        const mediaId = this.dataset.featuredMediaId;
        if (!mediaId) return;
        const root = rootOf(this);
        const target = this.dataset.section + '-' + mediaId;
        root.querySelectorAll('media-gallery, [id^="MediaGallery-"]').forEach(gallery => {
          if (!gallery.id.startsWith('MediaGallery-' + this.dataset.section)) return;
          if (typeof gallery.setActiveMedia === 'function') { gallery.setActiveMedia(target, true); return; }
          const viewer = gallery.querySelector('[id^="GalleryViewer"]');
          const active = viewer && Array.from(viewer.querySelectorAll('[data-media-id]')).find(el => el.dataset.mediaId === target);
          if (!active) return;
          viewer.querySelectorAll('[data-media-id]').forEach(el => el.classList.toggle('is-active', el === active));
          active.parentElement.prepend(active);
        });
        // Product media modals can be moved to body by the theme; their IDs are namespaced.
        const content = document.querySelector('#' + CSS.escape('ProductModal-' + this.dataset.section) + ' .product-media-modal__content');
        const active = content && Array.from(content.querySelectorAll('[data-media-id]')).find(el => el.dataset.mediaId === mediaId);
        if (active) content.prepend(active);
      },
      updatePickupAvailability() {
        if (this.closest('quick-add-modal')) return;
        const pickup = rootOf(this).querySelector('pickup-availability');
        if (!pickup) return;
        if (this.currentVariantId && typeof pickup.fetchAvailability === 'function') pickup.fetchAvailability(this.currentVariantId);
        else { pickup.removeAttribute('available'); pickup.innerHTML = ''; }
      },
      updateStickyATC(html) {
        if (this.closest('quick-add-modal')) return;
        const source = html.querySelector('.sticky-atc');
        const target = rootOf(this).querySelector('.sticky-atc');
        if (source && target) target.innerHTML = localHTML(this, source.innerHTML);
        // Includes external form-associated sticky buttons; never trust a nil availability test.
        this.updateBuyButton(html);
      },
      updateTiered(html) {
        const sources = html.querySelectorAll('.tiered-option__content');
        const targets = rootOf(this).querySelectorAll('.tiered-option__content');
        if (sources.length !== targets.length) return;
        targets.forEach((target, index) => {
          target.innerHTML = localHTML(this, sources[index].innerHTML);
          target.classList.toggle('hidden', !sources[index].innerHTML.trim());
        });
      },
      removeErrorMessage() {
        this.getVariantForms().forEach(form => form.closest('product-form')?.handleErrorMessage?.());
      },
      async renderSection() {
        const requested = this.getSelectionSignature();
        const revision = this.selectionRevision;
        const current = () => this.isConnected && revision === this.selectionRevision && requested === this.getSelectionSignature();
        if (!requested) { this.setBuyButtonLoading(false); this.showSelectionError(); return; }
        for (let attempt = 0; attempt < 2; attempt++) {
          if (!current()) return;
          const controller = new AbortController();
          this.abortController = controller;
          const timeout = setTimeout(() => controller.abort(), 8000);
          try {
            const url = new URL(this.dataset.url, location.origin);
            url.searchParams.delete('variant');
            url.searchParams.set('section_id', this.sectionId);
            url.searchParams.set('option_values', requested);
            const preview = new URL(location.href).searchParams.get('preview_theme_id');
            if (preview) url.searchParams.set('preview_theme_id', preview);
            if (attempt) url.searchParams.set('_variant_retry', String(Date.now()));
            const response = await fetch(url.toString(), { signal: controller.signal, cache: 'no-store', credentials: 'same-origin' });
            if (!response.ok) throw new Error('Section HTTP ' + response.status);
            const text = await response.text();
            if (!current()) return;
            if (controller.signal.aborted) throw new Error('Section timeout');
            const html = new DOMParser().parseFromString(text, 'text/html');
            if (!this.isRenderedSection(html)) throw new Error('Product section missing (possibly access/login page).');
            const source = this.sourcePicker(html);
            if (signature(source) !== requested) throw new Error('Server returned different options.');
            if (new URL(source.dataset.url, location.origin).pathname !== new URL(this.dataset.url, location.origin).pathname) throw new Error('Server returned another product.');
            if (!this.getVariantForms().some(form => form.getAttribute('id') === 'product-form-' + this.dataset.section)) throw new Error('Local product form missing.');
            this.updatePicker(html);
            this.updateProductInfo(html);
            this.updateVariantInput(html);
            this.updateStickyATC(html);
            this.updateBuyButton(html);
            // Cosmetics and optional theme features cannot turn a confirmed variant into a network error.
            optional('media', () => this.updateMedia());
            optional('share', () => this.updateShareUrl());
            optional('pickup', () => this.updatePickupAvailability());
            optional('tiered', () => this.updateTiered(html));
            if (!this.closest('quick-add-modal')) optional('URL', () => this.updateURL());
            this.unlockVariantForms();
            this.clearSelectionError();
            this.setBuyButtonLoading(false);
            optional('focus', () => this.restoreFocus());
            this.getVariantForms().forEach(form => optional('variant change event', () => form.querySelector('input[name="id"]')?.dispatchEvent(new Event('change', { bubbles: true }))));
            return;
          } catch (error) {
            if (!current()) return;
            this.lockVariantForms();
            if (attempt === 1) {
              this.dataset.variantState = 'error';
              this.setBuyButtonLoading(false);
              this.showSelectionError();
              console.error('YLB: unconfirmed variant blocked.', error);
            }
          } finally { clearTimeout(timeout); }
        }
      }
    });

    // Capture before existing bound product-form submit handlers, including Quick-Add.
    document.addEventListener('submit', event => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.closest('product-form')) return;
      const root = form.closest('quick-add-modal') || form.closest('[id^="MainProduct-"]') || form.closest('.shopify-section') || form.closest('section');
      const picker = root && Array.from(root.querySelectorAll('variant-radios, variant-selects')).find(el => 'product-form-' + el.dataset.section === form.getAttribute('id'));
      if (!picker) return;
      const input = form.querySelector('input[name="id"]');
      const unconfirmed = form.dataset.variantPending === 'true' || dirty(picker) || !input || !input.value || input.disabled || (picker.dataset.confirmedSelection && (signature(picker) !== picker.dataset.confirmedSelection || input.value !== picker.dataset.confirmedVariant));
      if (!unconfirmed) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      form.closest('product-form').handleErrorMessage?.('Bitte warte, bis deine Auswahl übernommen wurde. Bei einer Fehlermeldung bitte „Auswahl erneut laden“ verwenden.');
    }, true);
    window.YLBVariantRepair.ready = true;
    document.querySelectorAll('variant-radios, variant-selects').forEach(picker => {
      if (dirty(picker) || ['pending', 'error'].includes(picker.dataset.variantState)) picker.onVariantChange();
    });
  });

  customElements.whenDefined('quick-add-modal').then(() => {
    const proto = customElements.get('quick-add-modal').prototype;
    proto.preventDuplicatedIDs = function () {
      const section = this.productElement.dataset.section;
      const modalKey = this.id || 'product';
      const runtime = 'quickadd-' + modalKey + '-' + section;
      this.productElement.innerHTML = this.productElement.innerHTML.split(section).join(runtime);
      this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach(el => { el.dataset.originalSection = section; });
    };
  });
})();
